'use client';

import { useEffect, useState } from 'react';

import { windowResizeObserver } from '../lib/window-resize-observer';

export const useWindowDimension = (enableDebounce = true) => {
  const [windowDimension, setWindowDimension] = useState<[number, number]>([
    0, 0,
  ]);

  useEffect(() => {
    const subscription = windowResizeObserver.subscribe(
      (width, height) =>
        setWindowDimension((currentDimension) => {
          if (currentDimension[0] === width && currentDimension[1] === height) {
            return currentDimension;
          }
          return [width, height];
        }),
      enableDebounce
    );

    return () => subscription.unsubscribe();
  }, [enableDebounce]);

  return windowDimension;
};
